module.exports = __webpack_public_path__ + "img/logo_skyblue.a08f029b.svg";